export default "/logo-fluence.png";